<template>
  <div class="relative grid grid-cols-0 md:grid-cols-6 text-center bg-white py-10 lg:py-20">
    <div class="col-span-4 col-start-1 gap-x-12">
      <div class="text-left col-start-1 flex flex-col">
        <p class="text-14 text-black font-poppins tracking-widest my-0 py-0">CONTACT</p>
        <img class="w-1/3 py-2 my-0" src="https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/help-txt.png"/>
        <p class="text-lg text-black font-poppins tracking-normal my-0 py-0">We're here for you - choose any help option below.</p>
      </div>
    </div>
    <div class="col-span-1 text-16 font-black text-left pt-10 justify-end">
      <p class="font-poppins-bold text-md">Customer Service</p>
      <p class="font-poppins font-bold my-0">Monday - Friday</p>
      <p class="font-poppins font-thin my-0">8:30am - 6pm AEDT</p>
      <p class="font-poppins font-bold pt-4 my-0">Saturday, Sunday & National Public Holidays</p>
      <p class="font-poppins font-thin my-0">Closed</p>
    </div>
    <div class="col-span-1 text-16 font-black text-left pt-10 justify-end pl-8">
      <p class="font-poppins-bold text-md">Technical Support</p>
      <p class="font-poppins font-bold my-0">Monday - Friday</p>
      <p class="font-poppins font-thin my-0">8am - 9pm AEDT</p>
      <p class="font-poppins font-bold pt-4 my-0">Saturday & Sunday</p>
      <p class="font-poppins font-thin my-0">9am - 9pm AEDT</p>
      <p class="font-poppins font-bold pt-4 my-0">National Public Holidays</p>
      <p class="font-poppins font-thin my-0">Closed</p>
    </div>
  </div>
  <div class="grid grid-cols-0 md:grid-cols-2 gap-x-6 gap-y-4">
    <div class="bg-phone px-4 md:px-10 py-6 md:py-10 rounded-md">
      <div class="w-full lg:w-1/2">
        <h3 class="font-poppins-bold text-3xl text-white leading-tight py-0 my-0">Here for you<br> on the phone</h3>
        <p class="text-white font-poppins text-lg py-4 my-0 mb-10">{{ brandService.getSupportPhoneNumber() }}</p>
        <div class="w-full md:max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-dark to-brand-primary-light p-0.5 shadow-md">
            <button class="flex-1 text-lg md:text-18 bg-transparent px-6 py-3 rounded-full font-poppins border-none hover:cursor-pointer">
                <a class="no-underline text-black hover:text-white" :href="`tel:${brandService.getSalesPhoneNumber()}`">Call us Now</a>
            </button>
        </div>
      </div>
    </div>
    <div class="bg-email px-4 md:px-10 py-6 md:py-10 rounded-md">
      <div class="w-full lg:w-1/2">
        <h3 class="font-poppins-bold text-3xl text-white leading-tight py-0 my-0">Here for you<br>by email</h3>
        <p class="text-white font-poppins text-lg py-4 my-0 mb-10">{{ brandService.getSupportEmail() }}</p>
        <div class="w-full md:max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-dark to-brand-primary-light p-0.5 shadow-md">
              <button class="flex-1 text-lg md:text-18 bg-transparent px-6 py-3 rounded-full font-poppins border-none hover:cursor-pointer" @onClick="'mailto:' + brandService.getSupportEmail()">
                  <a class="no-underline text-black hover:text-white" :href="`mailto:${brandService.getSupportEmail()}`">Email us Now</a>
              </button>
          </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, RenderFunction } from 'vue';
import {
  PhoneIcon,
  MailIcon,
  HomeIcon
} from '@heroicons/vue/outline';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '../../services/integration/enums';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

type Feature = {
  name: string,
  icon: string|RenderFunction,
  description: string
}

const props = defineProps<{
  features: Array<Feature>
}>();

props.features.forEach(feature => {
  if (feature.icon === 'MailIcon') {
    feature.icon = MailIcon;
  } else if (feature.icon === 'PhoneIcon') {
    feature.icon = PhoneIcon;
  } else if (feature.icon === 'HomeIcon') {
    feature.icon = HomeIcon;
  }
});

</script>

<style scoped>
.bg-phone {
  background-color: #000;
  background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/herephone.png");
  background-position: center;
  background-size: cover;
}
.bg-email {
  background-color: #000;
  background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/heremail.png");
  background-position: center;
  background-size: cover;
}

</style>
